import { BankOutlined, ClusterOutlined, UserOutlined } from '@ant-design/icons';

import { TONG_ICON_LOAI_DON_VI } from '../../constants';
import type { LoaiDonVi } from '../../types';

/** Biểu tượng loại đơn vị nhận nhiệm vụ: cơ quan, phòng ban, cá nhân; `mau` thì tô theo tông phân loại. */
export function IconLoaiDonVi({ loai, mau = false }: { loai: LoaiDonVi; mau?: boolean }) {
  const cls = mau ? TONG_ICON_LOAI_DON_VI[loai] : undefined;
  if (loai === 'CO_QUAN') return <BankOutlined className={cls} aria-hidden />;
  if (loai === 'PHONG_BAN') return <ClusterOutlined className={cls} aria-hidden />;
  return <UserOutlined className={cls} aria-hidden />;
}
